import { environment } from '../environments/environment';


export const languages = [
    {
        key: 'en',
        value: 'English',
    },
    {
        key: 'de',
        value: 'Deutsch',
    },
];


export const DEFAULT_LANGUAGE = 'de';
export const DE_LANGUAGE = 'de';
export const EN_LANGUAGE = 'en';

export const BRANCHS = [
    'Beratung/Consulting',
    'Bildung',
    'Chemie',
    'Dienstleistung',
    'Druck/Verpackung',
    'IT',
    'Einkauf',
    'Elektro/Elektronik',
    'Energie',
    'Finanz',
    'Forschung/Entwicklung',
    'Gesundheit/Soziales/Pflege',
    'Handel',
    'Handwerk',
    'Immobilien',
    'Industrie',
    'Internet',
    'Kunst/Kultur',
    'Marketing/Werbung/PR',
    'Marktforschung',
    'Maschinenbau',
    'Medien',
    'Medizin/Pharma',
    'Medizintechnik',
    'Nahrungsmittel/Landwirtschaft',
    'Personalwesen & -beschaffung',
    'Recht',
    'Seminare/Messen',
    'Sonstige Branchen',
    'Sport/Beauty',
    'Steuerberatung/Wirtschaftsprüfung',
    'Telekommunikation',
    'Textil',
    'Tourismus/Gastronomie',
    'Vereine',
    'Transport/Verkehr/Logistik',
    'Versicherung',
    'Öffentliche Verwaltung',
];

export const STATES = [
    'Baden-Württemberg',
    'Bayern',
    'Berlin',
    'Brandenburg',
    'Bremen',
    'Hamburg',
    'Hessen',
    'Mecklenburg-Vorpommern',
    'Niedersachsen',
    'Nordrhein-Westfalen',
    'Rheinland-Pfalz',
    'Saarland',
    'Sachsen',
    'Sachsen-Anhalt',
    'Schleswig-Holstein',
    'Thüringen',
];

export const MODES_OF_TRANSPORT = ['car', 'other'];

export const RELATIONSHIP_TYPES = ['spouse', 'registered-life-partner', 'kind'];
export const ONLY_CHILD_RELATIONSHIP = ['kind'];

export const BAV_DENIED = 'BAV_DENIED';

export const MIN_WIDTH_SUPPORT = '1366px';
export const MIN_HEIGHT_SUPPORT = '768px';

/**
 * Firebase data
 */
export const FIREBASE_REGION = 'europe-west1';
export const FIREBASE_URL_FUNCTIONS = `https://${FIREBASE_REGION}-${environment.firebaseConfig.projectId}.cloudfunctions.net/`;
export const FIREBASE_STORAGE_BUCKET_BASE_URL = `https://firebasestorage.googleapis.com/v0/b/${environment.firebaseConfig.storageBucket}/o/`;

/**
 * Firebase functions
 */
export const GET_EMPLOYEE_BENEFITS_SERVICES = 'getEmployeeBenefitsServices';
export const CREATE_REPORT_FUNCTION = 'createReport';
export const COMPANY_ADVANTAGE_CALCULATE_FUNCTION = 'companyAdvantageCalculate';
export const CREATE_COMPANY_LEAD = 'addCompanyLead';
export const COP_REQUEST_RESET_PASSWORD_FUNCTION =
    'employeeRequestResetPassword';
export const COP_CHANGE_PASSWORD_FUNCTION = 'employeeChangePassword';
export const GET_EMPLOYEE_BY_RESET_PASSWORD_KEY =
    'getEmployeeByResetPasswordKey';
export const GET_COMPANY_LEAD_BY_RESET_PASSWORD_KEY =
    'getCompanyLeadByResetPasswordKey';
export const UPDATE_PERSON_SMARTPHONE_DATA = 'updatePersonSmartphoneData';
export const UPDATE_EMPLOYEE_FORM_DATA = 'updateEmployeeFormData';
export const RESET_CURRENT_STORE_CART = 'resetCurrentStoreCart';
export const UPDATE_SERVICE_SELECTION_FUNCTION = 'updateServiceSelection';
export const EMPLOYEE_ADVANTAGE_CALCULATE_FUNCTION =
    'employeeAdvantageCalculate';
export const GET_PRODUCTS_FOR_EMPLOYEE_FUNCTION = 'getProductsForEmployee';
export const CONFIRM_COP_FINALIZATION = 'confirmCopFinalization';
export const GENERATE_CONTRACT_PREVIEW = 'generateContractPreview';
export const RECAPTCHA_VALIDATOR_FUNCTION = 'recaptchaValidator';
export const CREATE_SUPPORT_REQUEST_FUNCTION = 'createSupportRequest';
export const CONFIRM_COP_WITHOUT_OPTIMIZATION_FUNCTION =
    'confirmCopWithoutOptimization';

/**
 * Firebase query operators
 */
export const OP_EQUALS = '==';

/**
 * Local Storage keys
 */
export const LANG_KEY_LOCAL_STORAGE_KEY = 'langKey';
export const ALLOW_COOKIES_LOCAL_STORAGE_KEY = 'allowCookies';
export const USER_LOCAL_STORAGE_KEY = 'user';
export const HELPER_EMPLOYEE_ID_TARGET_STORAGE_KEY = 'helperEmployeeIdTarget';

/**
 * Firebase collections
 */
export const USERS_COLLECTION = 'users';
export const COMPANY_LEADS_COLLECTION = 'company-leads';
export const EMPLOYEES_COLLECTION = 'employees';
export const EMPLOYEES_READ_ONLY_COLLECTION = 'employees-read-only';
export const COMPANIES_COLLECTION = 'companies';
export const ADDRESSES_COLLECTION = 'addresses';
export const BENEFITS_SERVICES_COLLECTION = 'benefits-services';
export const COLLECTION_CONSULTANCY_PROCESS = 'consultancy-process';
export const COLLECTION_PRODUCTS = 'products';
export const COLLECTION_STORE_CART = 'store-cart';
export const VIDEO_GALLERY_COLLECTION = 'video-gallery';
export const SERVICES_COLLECTION = 'services';
export const DNS_CONFIG_COLLECTION = 'dns-config';

/**
 * Patterns
 */
export const EMAIL_REGEX = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,15}$';

/**
 * System's status
 */
export const STATUS_ACTIVE = 'ACTIVE';
export const STATUS_APPROVED = 'APPROVED';
export const STATUS_DATA_COMPLETED = 'DATA COMPLETED';
export const STATUS_DATA_EXPORT_PENDING = 'DATA_EXPORT_PENDING';
export const STATUS_PENDING_OPTIN = 'PENDING_OPTIN';
export const STATUS_INACTIVE = 'INACTIVE';
export const STATUS_PENDENT = 'PENDENT';
export const STATUS_OUT_OF_RANGE = 'OUT_OF_RANGE';
export const STATUS_FULL = 'FULL';
export const STATUS_DISABLED = 'DISABLED';
export const STATUS_DISABLED_BY_MOBILE_CONTRACT = 'DISABLED_BY_MOBILE_CONTRACT';
export const READY_FOR_CONSULTATION_PROCESS = 'READY_FOR_CONSULTATION_PROCESS';
export const IN_THE_CONSULTING_PROCESS = 'IN_THE_CONSULTING_PROCESS';
export const MINIMUM_WAGE_NOT_REACHED = 'MINIMUM_WAGE_NOT_REACHED';
/**
 * Video URLS
 */

/**
 * FAQ steps index
 */

/**
 * COP steps index
 */
export const COP_WELCOME_STEP_INDEX = 0;
export const COP_QUESTIONS_AND_ANSWERS_STEP_INDEX = 1;
export const COP_NET_BENEFIT_HOME_STEP_INDEX = 2;
export const COP_EMPLOYEE_FORM_STEP_INDEX = 3;
export const COP_SMARTPHONE_COLLECT_PERSON_LIST_STEP_INDEX = 4;
export const COP_DETERMINE_NET_BENEFIT_HOME_STEP_INDEX = 5;
export const COP_IMPORTANT_INFO_STEP_INDEX = 6;
export const COP_SERVICES_SELECTION_STEP_INDEX = 7;
export const COP_SUMMARY_SERVICES_SELECTION_STEP_INDEX = 8;
export const COP_CONFIRM_NO_SERVICES_SELECTION_STEP_INDEX = 9;
export const COP_DISTRIBUTE_NET_BENEFIT_WELCOME_STEP_INDEX = 10;
export const COP_SELECTION_SLIDER_STEP_INDEX = 11;
export const COP_DISTRIBUTING_CONFIRMATION_TABLE_STEP_INDEX = 12;
export const COP_NOT_POSSIBLE_TO_CHOOSE_SMARTPHONE_STEP_INDEX = 13;
export const COP_STORE_WELCOME_STEP_INDEX = 14;
export const COP_FAMILY_MEMBER_LIST_STEP_INDEX = 15;
export const COP_STORE_SUMMARY_STEP_INDEX = 16;
export const COP_STORE_NO_SMARTPHONE_ALLOWED_STEP_INDEX = 17;
export const COP_CONTRACT_PREVIEW_STEP_INDEX = 18;
export const COP_FINALIZATION_STEP_INDEX = 19;

// Max values
export const COP_MAX_WORKING_DAYS_PEY_WEEK = 7;
export const COP_MAX_WORK_DISTANCE_IN_KM = 400;
export const COP_MAX_MONTHLY_COSTS_PUBLIC_TRANSPORT = 500;

// Services of group one
export const SERVICE_MOBILE = 'mobile';
export const SERVICE_MOBILE_CONTRACT = 'mobile-contract';
export const SERVICE_EMPLOYEE_DISCOUNT = 'employee-discount';
export const SERVICE_RECREATIONAL_ACTIVITIES = 'recreational-activities';
export const SERVICE_RESTAURANT = 'restaurant';
export const SERVICE_CASH_REGISTER = 'cash-register';
export const SERVICE_HARDWARE = 'hardware';
export const SERVICE_RETIREMENT = 'retirement';
export const SERVICE_SALARY_INCREASE_SUMMARY = 'salary-increase';
export const SERVICE_JOB_TICKET = 'job-ticket';

// Services of group two
export const SERVICE_COUPON = 'coupon';
export const SERVICE_COMMUTE = 'commute';
export const SERVICE_BIRTHDAY = 'birthday';
export const SERVICE_CHILDCARE = 'childcare';

export const SERVICES_GROUP_1 = [
    SERVICE_MOBILE,
    SERVICE_MOBILE_CONTRACT,
    SERVICE_EMPLOYEE_DISCOUNT,
    SERVICE_RECREATIONAL_ACTIVITIES,
    SERVICE_RESTAURANT,
    SERVICE_CASH_REGISTER,
    SERVICE_JOB_TICKET,
];


export const MEAL_FRINGE_BENEFIT_VALUE = 4.4; // "Sachbezugswert" for meals to be flat rate taxed
export const MEAL_EMPLOYEE_CONTRIBUTION = 3.1; // value for the tax free employer contribution

export const MAX_VALUE_AVG_FREQUENCY_BUSINESS_TRIP = 31;
export const MAX_VALUE_SERVICE_RESTAURANT_PER_DAY =
    MEAL_FRINGE_BENEFIT_VALUE + MEAL_EMPLOYEE_CONTRIBUTION;
export const YEAR_MONTH_QUANTITY = 12;
export const AGE_TO_RETIRE = 67;
export const MAX_VALUE_SERVICE_BUY_GOODS_MAX_ALLOWED = 90;
export const MAX_VALUE_INTERNET_COSTS = 50;
export const MAX_VALUE_PHONE_CONTRACT_COSTS = 200;
export const MAX_VALUE_CHILD_COSTS = 1500.0;

export const PERSON_AGE_LIMIT_FOR_SMARTPHONE = 12;

export const MAXIMUM_AGE_BAV = 62; // 1960
export const MINIMUM_BAV_PAYMENT = 30;
export const MAXIMUM_BAV_DEPOSIT = 292;

/* Auth params */
export const AUTH_EXPIRATION_TIME = environment.authExpirationTime;
export const AUTH_RECOVERY_TIME = environment.authRecoveryTime;
export const INACTIVE_MODAL_ID = 'inactive-close-modal';
export const INACTIVE_PING_CHECK = 60;

/**
 * Response code error constants
 */
export const RESP_CODE_OK = 'ok';
export const RESP_CODE_ALREADY_EXISTS = 'already-exists';

/**
 * Analytics constants
 */
export const GTAG_KEY = 'G-YFMDH3G8KT';
export const FB_PIXEL_KEY = '678301010575334';


export const PARTNER_COMPANIES = [
    {
        name: 'adidas',
        image: '../assets/images/partners/adidas.png',
        imageAvif: '../assets/images/partners/adidas.avif',
        imageWebp: '../assets/images/partners/adidas.webp',
    },
    {
        name: "ALDI Nord",
        image: "../assets/images/partners/aldi.jpg",
        imageAvif: "../assets/images/partners/aldi.avif",
        imageWebp: "../assets/images/partners/aldi.webp",
    },
    {
        name: 'Apollo-Optik DE',
        image: '../assets/images/partners/apollo-optik.jpg',
        imageAvif: '../assets/images/partners/apollo-optik.avif',
        imageWebp: '../assets/images/partners/apollo-optik.webp',
    },
    {
        name: 'aral',
        image: '../assets/images/partners/aral.jpg',
        imageAvif: '../assets/images/partners/aral.avif',
        imageWebp: '../assets/images/partners/aral.webp',
    },
    {
        name: 'Baby-Walz DE',
        image: '../assets/images/partners/baby-walz.jpg',
        imageAvif: '../assets/images/partners/baby-walz.avif',
        imageWebp: '../assets/images/partners/baby-walz.webp',
    },
    {
        name: 'c&a',
        image: '../assets/images/partners/ca.jpg',
        imageAvif: '../assets/images/partners/ca.avif',
        imageWebp: '../assets/images/partners/ca.webp',
    },
    {
        name: 'christ',
        image: '../assets/images/partners/chirst.jpg',
        imageAvif: '../assets/images/partners/chirst.avif',
        imageWebp: '../assets/images/partners/chirst.webp',
    },
    {
        name: 'conrad',
        image: '../assets/images/partners/conrad.jpg',
        imageAvif: '../assets/images/partners/conrad.avif',
        imageWebp: '../assets/images/partners/conrad.webp',
    },
    {
        name: "Domino's Pizza",
        image: "../assets/images/partners/dominos.jpg",
        imageAvif: "../assets/images/partners/dominos.avif",
        imageWebp: "../assets/images/partners/dominos.webp",
    },
    {
        name: 'douglas',
        image: '../assets/images/partners/douglas.jpg',
        imageAvif: '../assets/images/partners/douglas.avif',
        imageWebp: '../assets/images/partners/douglas.webp',
    },
    {
        name: "Ernsting's family DE",
        image: '../assets/images/partners/ernstingsfamily.jpg',
        imageAvif: '../assets/images/partners/ernstingsfamily.avif',
        imageWebp: '../assets/images/partners/ernstingsfamily.webp',
    },
    {
        name: 'Fleurop DE',
        image: '../assets/images/partners/fleurop.jpg',
        imageAvif: '../assets/images/partners/fleurop.avif',
        imageWebp: '../assets/images/partners/fleurop.webp',
    },
    {
        name: 'futterhaus',
        image: '../assets/images/partners/futterhaus.jpg',
        imageAvif: '../assets/images/partners/futterhaus.avif',
        imageWebp: '../assets/images/partners/futterhaus.webp',
    },
    {
        name: 'globetrotter',
        image: '../assets/images/partners/globetrotter.jpg',
        imageAvif: '../assets/images/partners/globetrotter.avif',
        imageWebp: '../assets/images/partners/globetrotter.webp',
    },
    {
        name: "GO Universalgutschein",
        status: "ACTIVE",
        image: "../assets/images/partners/gouniversalgutschein.jpg",
        imageAvif: "../assets/images/partners/gouniversalgutschein.avif",
        imageWebp: "../assets/images/partners/gouniversalgutschein.webp",
    },
    {
        name: 'h&m',
        image: '../assets/images/partners/hm.png',
        imageAvif: '../assets/images/partners/hm.avif',
        imageWebp: '../assets/images/partners/hm.webp',
    },
    {
        name: 'Hunkemöller DE',
        image: '../assets/images/partners/hunkemoller.jpg',
        imageAvif: '../assets/images/partners/hunkemoller.avif',
        imageWebp: '../assets/images/partners/hunkemoller.webp',
    },
    {
        name: 'ikea',
        image: '../assets/images/partners/ikea.png',
        imageAvif: '../assets/images/partners/ikea.avif',
        imageWebp: '../assets/images/partners/ikea.webp',
    },
    {
        name: "Jacques Wein-Depot",
        status: "ACTIVE",
        image: "../assets/images/partners/jacques.jpg",
        imageAvif: "../assets/images/partners/jacques.avif",
        imageWebp: "../assets/images/partners/jacques.webp",
    },
    {
        name: 'kaufland',
        image: '../assets/images/partners/kaufland.jpg',
        imageAvif: '../assets/images/partners/kaufland.avif',
        imageWebp: '../assets/images/partners/kaufland.webp',
    },
    {
        name: "Lieferando",
        status: "ACTIVE",
        image: "../assets/images/partners/lieferando.jpg",
        imageAvif: "../assets/images/partners/lieferando.avif",
        imageWebp: "../assets/images/partners/lieferando.webp",
    },
    {
        name: 'Louis Motorrad',
        image: '../assets/images/partners/louismotorrad.jpg',
        imageAvif: '../assets/images/partners/louismotorrad.avif',
        imageWebp: '../assets/images/partners/louismotorrad.webp',
    },
    {
        name: 'media markt',
        image: '../assets/images/partners/mediamarket.jpg',
        imageAvif: '../assets/images/partners/mediamarket.avif',
        imageWebp: '../assets/images/partners/mediamarket.webp',
    },
    {
        name: 'OBI DE',
        image: '../assets/images/partners/obi.jpg',
        imageAvif: '../assets/images/partners/obi.avif',
        imageWebp: '../assets/images/partners/obi.webp',
    },
    {
        name: 'penny',
        image: '../assets/images/partners/penny.png',
        imageAvif: '../assets/images/partners/penny.avif',
        imageWebp: '../assets/images/partners/penny.webp',
    },
    {
        name: 'rewe',
        image: '../assets/images/partners/rewe.jpg',
        imageAvif: '../assets/images/partners/rewe.avif',
        imageWebp: '../assets/images/partners/rewe.webp',
    },
    {
        name: 'Rituals DE',
        image: '../assets/images/partners/rituals.jpg',
        imageAvif: '../assets/images/partners/rituals.avif',
        imageWebp: '../assets/images/partners/rituals.webp',
    },
    {
        name: 'rossmann',
        image: '../assets/images/partners/rossamann.jpg',
        imageAvif: '../assets/images/partners/rossamann.avif',
        imageWebp: '../assets/images/partners/rossamann.webp',
    },
    {
        name: 's.Oliver',
        image: '../assets/images/partners/soliver.jpg',
        imageAvif: '../assets/images/partners/soliver.avif',
        imageWebp: '../assets/images/partners/soliver.webp',
    },
    {
        name: 'SB Tankgutschein',
        image: '../assets/images/partners/sbtankgutschein.png',
        imageAvif: '../assets/images/partners/sbtankgutschein.avif',
        imageWebp: '../assets/images/partners/sbtankgutschein.webp',
    },
    {
        name: 'tchibo',
        image: '../assets/images/partners/tchibo.jpg',
        imageAvif: '../assets/images/partners/tchibo.avif',
        imageWebp: '../assets/images/partners/tchibo.webp',
    },
    {
        name: 'thalia',
        image: '../assets/images/partners/thalia.jpg',
        imageAvif: '../assets/images/partners/thalia.avif',
        imageWebp: '../assets/images/partners/thalia.webp',
    },
    {
        name: 'toom baumarkt',
        image: '../assets/images/partners/toom.jpg',
        imageAvif: '../assets/images/partners/toom.avif',
        imageWebp: '../assets/images/partners/toom.webp',
    },
    {
        name: 'TUI DE',
        image: '../assets/images/partners/tui.jpg',
        imageAvif: '../assets/images/partners/tui.avif',
        imageWebp: '../assets/images/partners/tui.webp',
    },
];

export const SLIDER_DETAILS_COLOR = '--sliderDetailsColor';
export const SLIDER_LEFT_BOTTOM_FIRST_COLOR = '--sliderLeftBottomFirstColor';
export const SLIDER_LEFT_BOTTOM_SECOND_COLOR = '--sliderLeftBottomSecondColor';
export const SLIDER_LEFT_TOP_FIRST_COLOR = '--sliderLeftTopFirstColor';
export const SLIDER_LEFT_TOP_SECOND_COLOR = '--sliderLeftTopSecondColor';
export const SLIDER_RIGHT_BOTTOM_FIRST_COLOR = '--sliderRightBottomFirstColor';
export const SLIDER_RIGHT_BOTTOM_SECOND_COLOR =
    '--sliderRightBottomSecondColor';
export const SLIDER_RIGHT_TOP_COLOR = '--sliderRightTopColor';
